/**
 * Список доступных каналов для подписки через webSocket
 * должен совпадать с WsChannels.go
 */
export enum WebSocketChannels {
    OrderCreate = "order-create",
    OrderUpdate = "order-update",
}
